/* Built In Imports */
import { Box, Text } from '@chakra-ui/react';

/* External Imports */
import { render } from 'datocms-structured-text-to-html-string';

/* Services */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import useDateTimeCount from '@ieo/hooks/useDateTimeCount';
import { Fragment } from 'react';

/**
 *
 * @param {*} currentDate
 * @returns
 */
export default function DayTimeCounterText({
  currentDate,
  endDate,
  sectionContent,
  isMobile,
  ...props
}) {
  const { timeLeft, offerExtendedDate } = useDateTimeCount(
    currentDate,
    endDate
  );
  // console.log('{ timeLeft, offerExtendedDate }', {
  //   timeLeft,
  //   offerExtendedDate,
  // });

  const greyBannerText5 = sectionContent?.find(
    e => e.fieldId === 'grey-banner-text5'
  );
  const greyBannerText6 = sectionContent?.find(
    e => e.fieldId === 'grey-banner-text6'
  );
  const greyBannerText7 = sectionContent?.find(
    e => e.fieldId === 'grey-banner-text7'
  );
  const greyBannerText8 = sectionContent?.find(
    e => e.fieldId === 'grey-banner-text8'
  );
  // const offerEndText = sectionContent?.find(
  //   e => e.fieldId === 'offer-end-text'
  // );
  const offerExtendedText = sectionContent?.find(
    e => e.fieldId === 'offer-extended-text'
  );

  // Function to clean up the rendered text
  let cleanText = text =>
    render(text)?.replace(/<p>/g, '').replace(/<\/p>/g, '');

  return (
    <>
      {isMobile && timeLeft ? (
        <Box
          as="span"
          display={'flex'}
          alignItems="center"
          color="#C07513"
          textAlign="center"
          fontSize={{ md: '16px', lg: '24px' }}
          mt="0"
          {...props}
        >
          {timeLeft.type === 'timer' ? (
            <Box as="span" display="flex">
              {cleanText(greyBannerText5?.body)}
              {timeLeft.hours} {cleanText(greyBannerText7?.body)}:
              {timeLeft.minutes} {cleanText(greyBannerText8?.body)}{' '}
            </Box>
          ) : (
            <>
              <Text>{timeLeft.days}</Text>
              <Text ms="5px">{cleanText(greyBannerText6?.body)}</Text>
            </>
          )}
        </Box>
      ) : (
        <Box
          as="span"
          // ml="14px"
          fontSize={{ base: '16px', md: '20px' }}
          color={props.color ? props.color : '#CD3C4C'}
          lineHeight={{ base: '20.4px', md: '25.5px' }}
          fontWeight={600}
          py="10px"
          fontFamily={{ md: 'FedraSansStd-book' }}
        >
          {timeLeft ? (
            <Fragment>
              {timeLeft.type === 'timer' ? (
                <>
                  ( {cleanText(greyBannerText5?.body)}
                  {timeLeft.days} Days : {timeLeft.hours}{' '}
                  {cleanText(greyBannerText7?.body)} : {timeLeft.minutes}{' '}
                  {cleanText(greyBannerText8?.body)} )
                </>
              ) : (
                <>
                  {offerExtendedDate ? (
                    <StructuredTextParser
                      pl="5px"
                      color="#CD3C4C"
                      textAlign="center"
                      fontFamily="FedraSansStd-medium"
                      fontSize={{ md: '16px', lg: '24px' }}
                      mt="0"
                      str={render(offerExtendedText?.body)} // end offer text
                    />
                  ) : (
                    <Box as="span" display={'flex'} alignItems="center">
                      {/* <StructuredTextParser
                        color="#CD3C4C"
                        textAlign="center"
                        fontFamily="FedraSansStd-medium"
                        fontSize={{ md: '16px', lg: '24px' }}
                        mt="0"
                        str={render(greyBannerText5?.body)}
                      /> */}
                      <Text
                        ml="5px"
                        color={props.color ? props.color : '#CD3C4C'}
                        textAlign="center"
                        fontFamily="FedraSansStd-medium"
                        fontSize={{ md: '26px', lg: '30px' }}
                      >
                        {timeLeft.days}
                      </Text>

                      <StructuredTextParser
                        pl="5px"
                        color={props.color ? props.color : '#CD3C4C'}
                        textAlign="start"
                        fontFamily="FedraSansStd-medium"
                        fontSize={{ md: '26px', lg: '30px' }}
                        mt="0"
                        str={render(greyBannerText6?.body)}
                      />
                    </Box>
                  )}
                </>
              )}
            </Fragment>
          ) : (
            <Box as="span" fontFamily="FedraSansStd-medium">
              {/* <StructuredTextParser
                color="#C07513"
                textAlign="center"
                fontFamily="FedraSansStd-medium"
                fontSize={{ md: '16px', lg: '24px' }}
                mt="0"
                str={render(offerEndText?.body)}
              /> */}
              <Text> </Text>
            </Box>
          )}
        </Box>
      )}
    </>
  );
}
